import React from "react";
import "./brand.scss";

import brand1 from "../../Assets/images/Brand/brand1.webp";
import brand2 from "../../Assets/images/Brand/brand2.webp";
import brand3 from "../../Assets/images/Brand/brand3.webp";
import brand4 from "../../Assets/images/Brand/brand4.webp";
import brand5 from "../../Assets/images/Brand/brand5.webp";
import brand6 from "../../Assets/images/Brand/brand6.webp";

const BrandImg = [
  {
    img: brand1,
    name: " brand1",
  },
  {
    img: brand2,
    name: " brand2",
  },
  {
    img: brand3,
    name: " brand3",
  },
  {
    img: brand4,
    name: " brand4",
  },
  {
    img: brand5,
    name: " brand5",
  },
  {
    img: brand6,
    name: " brand6",
  },
];

const Brands = () => {
  return (
    <div className="section brands">
      <div className="container">
        <h1 className="text-center">We shop good Quality!</h1>
        <div className="row my-5">
          {BrandImg.map((brand) => (
            <div className=" col-lg-2 col-md-3 col-sm-6 col-xs-12" data-aos="fade-up">
              <img className="brand__img" src={brand.img} alt={brand.name} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Brands;
